








































import { Component, Prop, Vue } from "vue-property-decorator";
import BaseNav from "@/components/base/template/vue-argon-design-template/BaseNav.vue";
import BaseDropdown from "@/components/base/template/vue-argon-design-template/BaseDropdown.vue";
import CloseButton from "@/components/base/template/vue-argon-design-template/CloseButton.vue";
import { Getter } from "vuex-class";
import { IUser } from "@/store/modules/auth/types";
import { ThemeConfig } from "@/plugins/config";

const namespace = "authModule";

@Component({
  name: "app-menu",
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
})
export default class AppMenu extends Vue {
  @Prop({ default: false })
  public isDemo!: boolean;

  @Getter("theme")
  public theme!: ThemeConfig;

  @Getter("account", { namespace })
  public account!: IUser;

  @Getter("hasHomeRoom", { namespace })
  public hasHomeRoom!: boolean;
}
